import * as React from 'react';

import { NavigationBack as NavigationBackIcon } from '@/components/icons';

import styles from './HeaderBackButton.module.scss';
import { HeaderProps } from './types';

interface HeaderBackButtonProps {
  backButtonText: HeaderProps['backButtonText'];
  onBackButtonClick: HeaderProps['onBackButtonClick'];
}

const HeaderBar: React.FC<HeaderBackButtonProps> = ({
  backButtonText,
  onBackButtonClick,
}) => {
  return (
    <div
      className={styles.wrapper}
      data-testid="header-back-button"
      onClick={onBackButtonClick}
    >
      <NavigationBackIcon className={styles.navigationBack} />
      <p className={styles.textWrapper}>{backButtonText}</p>
    </div>
  );
};

export default HeaderBar;
